import { render, staticRenderFns } from "./VideoRoomLeft.vue?vue&type=template&id=24620b7d&scoped=true&"
import script from "./VideoRoomLeft.vue?vue&type=script&lang=js&"
export * from "./VideoRoomLeft.vue?vue&type=script&lang=js&"
import style0 from "./VideoRoomLeft.vue?vue&type=style&index=0&id=24620b7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24620b7d",
  null
  
)

/* custom blocks */
import block0 from "./VideoRoomLeft.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VideoRoomLeft.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports